import { Gtm } from '@/domains/core/tracking/utils/Gtm';

export const GTM_CLICK_BRANDS = (brandUrl: string, brandText: string) => {
  Gtm.push({
    event: 'interaction_click on a link',
    e_category: 'navigation',
    e_action: 'Click on a link',
    e_label: brandText,
    amp_event_name: 'Click on a link',
    event_trigger: 'product_page',
    redirection_link: brandUrl,
    click_element: brandText,
    interaction_hit: 'False',
  });
};
